var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1Seven(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 9a29 29 0 100 57.999A29 29 0 0038 9zm0 54a25 25 0 110-50 25 25 0 010 50zm-6-34h12v2.76a12.281 12.281 0 00-2.39 2.91 20.131 20.131 0 00-1.77 3.67 24.125 24.125 0 00-1.08 3.95 20.904 20.904 0 00-.4 3.71h-3.74a23.51 23.51 0 011.81-7.43 26.391 26.391 0 014-6.57H32v-3z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Seven.f3fb6fce.svg";
export { SvgJ1Seven as ReactComponent };